import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { analyticsPage, consentKey, forgetLegacyAnalyticsCookies, readConsent } from "./analyticsPolicy";
import { setAnalyticsPage, stopAnalytics } from "./analytics";
import classes from "./AnalyticsConsent.module.css";

const AnalyticsConsent = () => {
  const { pathname } = useLocation();
  const [consent, setConsent] = useState(readConsent);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    forgetLegacyAnalyticsCookies();
    return stopAnalytics;
  }, []);
  useEffect(() => {
    setAnalyticsPage(consent, pathname);
  }, [consent, pathname]);
  useEffect(() => {
    const onStorage = event => { if (event.key === consentKey || event.key === null) setConsent(readConsent()); };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);
  const choose = choice => {
    if (choice !== "accepted") stopAnalytics();
    forgetLegacyAnalyticsCookies();
    try { localStorage.setItem(consentKey, choice); } catch { /* Keep the choice for this visit. */ }
    setConsent(choice); setOpen(false);
    setAnalyticsPage(choice, pathname);
  };
  if (!analyticsPage(pathname)) return null;
  if (consent && !open) return <button className={classes.choices} onClick={() => setOpen(true)}>Privacy choices</button>;
  return <section className={classes.banner} aria-label="Privacy choices">
    <h2>Optional usage analytics</h2>
    <p>Allow Google Analytics to help us understand which parts of Guitar Charts are used?
      Chart content and account links are excluded. Your choice does not affect chart editing or saving.</p>
    <div className={classes.actions}>
      <button onClick={() => choose("accepted")}>Allow usage analytics</button>
      <button onClick={() => choose("declined")}>Decline</button>
      <Link to="/privacy">Privacy notice</Link>
    </div>
    {consent && <button className={classes.close} onClick={() => setOpen(false)}>Keep current choice</button>}
  </section>;
};

export default AnalyticsConsent;
